import { useNavigate } from 'react-router-dom'
import { Done } from '../../../../../components/icons/done'
import { PageContainer } from '../../../../../components/page-container/page-container'
import { paths } from '../../../../../router/paths'

export const ResetSuccess = () => {
  const navigate = useNavigate()

  return (
    <PageContainer>
      <div className="flex h-screen w-full flex-col items-center justify-center gap-12 px-8">
        <div className="flex w-full flex-col items-center gap-4">
          <Done />
          <p>¡Pin cambiado con éxito!</p>
        </div>
        <span
          onClick={() => navigate(paths.authentication.login)}
          className="cursor-pointer font-normal text-[#2D4990] hover:underline"
        >
          Continuar
        </span>
      </div>
    </PageContainer>
  )
}
